import React from 'react';
import Form from 'jd-library/Form';

const CheckBox = ({ classN = "check-input-row", labelClass = "label-row", onChange, label, isChecked, isDisabled }) => {
    return (
        <Form.Check
            className={classN}
            labelClass={labelClass}
            onChange={onChange}
            label={label}
            checked={isChecked}
            disabled={isDisabled} />
    )
}

export default CheckBox